var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"input-tag"},[_vm._t("default"),(!_vm.disabled)?_c('a',{staticClass:"_remove",on:{"click":function($event){$event.stopPropagation();return _vm.$emit('remove', _vm.value)}}},[_vm._v("✕")]):_vm._e()],2)}
var staticRenderFns = []

export { render, staticRenderFns }